import { Button, Grid, Stack, Typography } from '@mui/material'
import moment from 'moment'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import NormalAbnormal from '../NormalAbnormal'
import AssessmentText from '../AssessmentText'
import BigModal from '../../../../../components/Modals/BigModal'
import CSpine from './CSpine'

const Trauma = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })
  const [openCSpineAssessment, setOpenCSpineAssessment] = useState(false)

  return (
    <Grid container spacing={2} alignItems="center" rowSpacing={{ lg: 2 }}>
      <Grid item xs={12} lg={6}>
        <Typography variant="title2">Trauma Assessment</Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <AnDateTimePicker
          date={moduleValues.dateTime}
          fullWidth
          size="small"
          onChange={(newDate) =>
            setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
          }
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <Button
          fullWidth
          onClick={() => setOpenCSpineAssessment(true)}
          color="anPurple"
          variant="outlined"
          size="large"
          sx={{ minHeight: '56px' }}
        >
          C-Spine Assessment
        </Button>
        <CSpine
          open={openCSpineAssessment}
          onClose={() => setOpenCSpineAssessment(false)}
          submitModule={submitModule}
        />
      </Grid>
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="C-Spine Assessment"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Spinal Assessment"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Thoracic Assessment"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Abdominal Assessment"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Pelvis Assessment"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Upper Limbs"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Lower Limbs"
      />
      <AssessmentText
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
      />
      <Grid item xs={12}>
        <Button
          onClick={() => submitModule('Trauma', moduleValues)}
          variant="contained"
          fullWidth
          color="success"
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}

export default Trauma
